import React, { useEffect } from "react";
import ChartObservations from "./chart-model/ChartObservations";
import ChartForecasts from "./chart-model/ChartForecasts";
import ChartSummaries from "./chart-model/ChartSummaries";
import DashboardChart from "./DashboardChart";
import { UnitStoreContainer } from "../../../../common/hooks/stores/useUnitStore";
import { UnitCategory } from "../../../../../types/enums";
import { ThemeContainer } from "../../../../common/hooks/useTheme";

export interface ChartProps {
  collection: ChartObservations | ChartForecasts | ChartSummaries;
  config: {};
  date: Date;
}

export default function WindDirectionChart({ collection, date, period, config }: ChartProps) {
  const { unitStore } = UnitStoreContainer.useContainer();
  const { theme } = ThemeContainer.useContainer();
  const dataColors = theme.components.charts.data;

  function labelConfigCallback(value: any) {
    switch (value) {
      case 0:
        return "N";
      case 90:
        return "E";
      case 180:
        return "S";
      case 270:
        return "W";
      case 360:
        return "N";
    }
  }

  const datasetConfigs = [
    {
      data: collection.windDirection,
      label: "Wind Direction",
      key: "windDirection",
      borderColor: dataColors.direction,
      pointBackgroundColor: dataColors.direction
    }
  ];

  return (
    <DashboardChart
      date={date}
      chartConfig={config}
      period={period}
      datasetConfigs={datasetConfigs}
      labelConfigCallback={labelConfigCallback}
      collection={collection}
      startsAtZero={true}
    />
  );
}
